export default "__VITE_ASSET__CpDS17SD__"